import { useState } from 'react';

import { cn } from '../cn';
import type { InputProps } from './Input';
import Input from './Input';
import Button from './Button';
import ButtonGroup from './ButtonGroup';
import { General } from '../StrokeIcons';

export default function PasswordInput({ className, size, ...props }: Omit<InputProps, 'type'>) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <ButtonGroup size={size} className={className}>
      <Input
        type={showPassword ? 'text' : 'password'}
        className={cn(className, 'flex-1 border-none! bg-transparent! focus-within:bg-transparent! hover:bg-transparent! outline-hidden!')}
        {...props}
      />
      <Button
        type="button"
        icon={showPassword ? <General.EyeOff /> : <General.Eye />}
        onClick={() => setShowPassword(!showPassword)}
        tooltip={showPassword ? 'Hide' : 'Show'}
        text
        className={cn(className, 'bg-transparent! hover:bg-transparent!')}
      />
    </ButtonGroup>
  );
}
